export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
            <path
                d="M9.94105 7.18619C9.45023 6.97148 8.90274 6.85156 8.32537 6.85156C6.21268 6.85156 4.5 8.4572 4.5 10.4379C4.5 10.9942 4.63515 11.521 4.87634 11.9909M6.48127 13.5807C7.02816 13.8633 7.65673 14.0241 8.32537 14.0241C10.4381 14.0241 12.1507 12.4185 12.1507 10.4379C12.1507 9.81214 11.9798 9.22385 11.6794 8.71179"
                stroke="url(#paint0_linear_567_5357)"
                strokeLinecap="round"
            />
            <path d="M8.96533 6.18555L9.94115 7.18552" stroke="#E6BC79" strokeLinecap="round" />
            <path d="M6.48145 13.5801L7.56048 14.7105" stroke="#D6A663" strokeLinecap="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.20907 9.96207H8.9009C8.9555 9.96207 8.99976 10.0102 8.99976 10.0696C8.99976 10.0892 8.99482 10.1085 8.98548 10.1253L7.99621 11.9043C7.97031 11.9508 7.9146 11.9658 7.87178 11.9376C7.83922 11.9161 7.82243 11.8749 7.82977 11.8342L8.04118 10.6635H7.34926C7.29467 10.6635 7.25041 10.6154 7.25041 10.556C7.25041 10.5364 7.25534 10.5172 7.26466 10.5004L8.25409 8.71941C8.27998 8.67281 8.33568 8.65787 8.37851 8.68604C8.41109 8.70746 8.42789 8.74875 8.42056 8.78939L8.20907 9.96207Z"
                fill="url(#paint1_linear_567_5357)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.3565 3.42261C10.9169 3.42261 8.95786 1.62862 8.94191 1.61341L8.5 1.18555L8.05353 1.61341C8.03531 1.63296 6.11731 3.42261 1.64123 3.42261C1.47267 3.42261 1.29954 3.42043 1.12415 3.41392L0.5 3.39437L0.5 11.5014C0.5 13.6298 1.30638 16.7356 8.28132 19.1117L8.5 19.1855L8.71868 19.1117C15.6936 16.7356 16.5 13.6298 16.5 11.5014V3.39437L15.8736 3.41392C15.6982 3.42043 15.5251 3.42261 15.3565 3.42261Z"
                stroke="url(#paint2_linear_567_5357)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_567_5357" x1="8.32537" y1="6.85156" x2="8.32537" y2="14.0241" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E5BB78" />
                    <stop offset="1" stopColor="#D5A562" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_5357" x1="9.2491" y1="8.9127" x2="7.66768" y2="12.0053" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EBC381" />
                    <stop offset="1" stopColor="#CF9C5A" />
                </linearGradient>
                <linearGradient id="paint2_linear_567_5357" x1="16" y1="2.6066" x2="6.77082" y2="18.6808" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="1" stopColor="#C99352" />
                </linearGradient>
            </defs>
        </svg>
    );
}
